import React from 'react'
import { StyledContact } from './styles/Contact.styled'
import { Twitter,Facebook,LinkedIn, Instagram } from '../../../../assets/svgs/svg'
import { Forms } from '../reusable_ui/Forms/Forms'
import  Button  from '../reusable_ui/button/Button';
import { Link } from 'react-router-dom'

const Contact = () => {
  return (
   <StyledContact>
    <div className='contact'>
        <div className="contact__main">
           <div className="contact__header">
               <h2 className="contact__title">Get in touch</h2>
              <p className="contact__desc">16 Amodu Ojikutu Street, Victoria Island, Lagos, Nigeria.
               <br />
                Email: <u>info@hydrocis.com</u>
              </p>
           </div>

             <div className="contact__media">
                  <div className='Fb'>  <Facebook /></div>
                  <div className='Twttr'> <Twitter /></div>
                  <div className='In'><LinkedIn /></div>
                  <div className='Ig'><Instagram /></div>
             </div>
        </div>
         
         <div className="contact__form">
           <Forms />
         </div>

    </div>

    <div className='access'>
      <div className='access__title'>
        <p>Try HydroCIS Now</p>
        <span>Get Access to quality safety and
           environmental Infomation
        </span>
      </div>

      <div className='signin__btn'>
      <Link to='/user/login'><Button>Sign In</Button></Link>
      </div>
    </div>
   </StyledContact>
  )
}

export default Contact